import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { diagnosticChangedSelector } from '../../diagnostic/selectors/user-diagnostic.selectors';
import { saveDiagnostic } from '../../diagnostic/thunks/save-diagnostic.thunk';
import { currentEcgIdSelector } from '../selectors/ecg-count.selectors';
import { ecgIdSelector } from '../selectors/ecg.selectors';
import { CustomButton } from './CustomButton';
import * as ecgCountActions from '../actions/ecg-count.actions';
import { SAVE_DIAGNOSTIC } from '../../analytics/analytics.constants';
import { trackEachSaveButton } from '../../analytics/thunks/trackEachSaveButton.thunk';
import { needToAssessSelector } from '../../autoLabels/selectors/auto-labels.selectors';
import * as autoLabelsActions from '../../autoLabels/actions/auto-labels.actions';
import { displayAutoLabelsToAssess } from '../../autoLabels/thunks/display-auto-labels-to-assess.thunk';
import { getLayoutValueSelector } from '../../layout/selectors/layout.selectors';

export const SaveDiagnostic: React.FC = () => {
  const dispatch = useDispatch();
  const withSuggestionsPanel = useSelector(
    getLayoutValueSelector('withSuggestionsPanel'),
  );
  const isForbidToSave = useSelector(needToAssessSelector);
  const changed = useSelector(diagnosticChangedSelector);
  const ecgId = useSelector(ecgIdSelector);
  const counterEcgId = useSelector(currentEcgIdSelector);

  const save = async () => {
    dispatch(trackEachSaveButton(SAVE_DIAGNOSTIC));
    if (counterEcgId !== ecgId && ecgId != null) {
      dispatch(ecgCountActions.increment({ ecgId }));
    }
    if (withSuggestionsPanel) {
      const needToAssessLabels = dispatch(
        displayAutoLabelsToAssess(),
      ) as unknown as boolean;
      if (needToAssessLabels) return;
    }
    await dispatch(saveDiagnostic());
    dispatch(
      autoLabelsActions.setAssessmentStatus({
        status: 'none',
        meta: { history: false },
      }),
    );
  };

  return (
    <>
      <CustomButton
        dataTestId='save-diag-btn'
        disabled={!changed || isForbidToSave}
        onClick={save}
      >
        Save diagnosis
      </CustomButton>
    </>
  );
};
